module.exports = __webpack_public_path__ + "static/img/logo-black.91bb100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-black.png
// module id = mxas
// module chunks = 2